import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';

export type Props = {
  value?: string,
  isVisible?: boolean,
  isDisabled?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseDigit',
  props: {
    value: { default: '' },
    isVisible: { type: Boolean, default: true },
    isDisabled: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { value: string, isVisible: boolean, isDisabled: boolean };



const isValue = computed(() => props.value.length);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["base-digit", {
      'base-digit--filled': _unref(isValue) && !__props.isVisible,
      'base-digit--borderless': _unref(isValue) && __props.isVisible,
      'base-digit--faded': __props.isDisabled
    }])
  }, _toDisplayString(__props.isVisible ? __props.value : ''), 3))
}
}

})